import { render, staticRenderFns } from "./kyc-application.vue?vue&type=template&id=51ef32c4&"
import script from "./kyc-application.vue?vue&type=script&lang=js&"
export * from "./kyc-application.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports